module.exports = __webpack_public_path__ + "img/banner.8d544b4.png";